import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

export default {
  name: 'home',

  data: function () {
    return {
      tableData: null,
      timestampData: null,
      notificationData: null,
      checkToggle: true,
      dashText: {},
      reportTotDuration: null,
      reportTotSuites: null,
      reportTotTests: null,
      reportTotPassed: null,
      reportTotFailed: null,
      reportTotSkipped: null,
      reportTotPending: null,
      reportSuites: null
    }
  },

  computed: {},

  methods: {
    /**
     * Parse data from mocha report
     * @param {*} report
     */
    parseMochaReportData: function (report) {
      if (report.hasOwnProperty('stats') && report.hasOwnProperty('suites')) {
        this.reportTotDuration = this.millisToMinutesAndSeconds(report.stats.duration)
        this.reportTotSuites = report.stats.suites ? report.stats.suites : 0
        this.reportTotTests = report.stats.tests ? report.stats.tests : 0
        this.reportTotPassed = report.stats.passes ? report.stats.passes : 0
        this.reportTotFailed = report.stats.failures ? report.stats.failures : 0
        this.reportTotSkipped = report.stats.skipped ? report.stats.skipped : 0
        this.reportTotPending = report.stats.pending ? report.stats.pending : 0
        this.reportSuites = report.suites ? report.suites : []
        this.timestampData = new Date(report.stats.end).toString()
      } else {
        console.error('report data not found')
      }
    },

    /**
     * Convert millis input to string format output.
     * @param {int} millis
     */
    millisToMinutesAndSeconds: function (millis) {
      if (millis < 1000) {
        return millis + 'ms'
      }
      let seconds = ((millis % 60000) / 1000).toFixed(0)
      if (millis < 60000) {
        return seconds + 's'
      }
      let minutes = Math.floor(millis / 60000)
      return minutes + ':' + (seconds < 10 ? '0' : '') + seconds + 'm'
    },

    getMochaTestReport: function () {
      this.$http.get(this.$hostIdp2 + 'v1/ondusapi/test/report',{
        headers: {
          'Authorization': 'Bearer ' + this.$store.getters.getAccessToken
        },
        params: {
          state_token: this.$store.getters.getStateToken
        },
        credentials: 'include'
      })
        .then(response => {
          if (response) {
            console.log('getMochaTestReport', response.body)
            this.parseMochaReportData(response.body)
          }
        })
        .catch(err => {
          this.$manageError(err)
        })
    },

    getNotices: function () {
      this.$http.get(this.$hostEps + 'notices/notices.json')
        .then(response => {
          if (response) {
            this.notificationData = response.body.text
          }
        })
        .catch(err => {
          console.error(err)
          this.notificationData = 'No notices found.'
        })
    }
  },

  created: function () {
    console.log('home')

    // Listen to $emit event
    this.$root.$on('headerToggle', (isToggle) => {
      this.checkToggle = isToggle
    })

    this.getNotices()

    this.getMochaTestReport()
  }

}



// WEBPACK FOOTER //
// ./src/components/home/home.js